// project-imports
import { getRequest } from 'utils/action-manager/actionManager';
import { APIAction } from '../apiManager';

// ==============================|| API MANAGER - LANDING ||============================== //

export async function handleLanding(action: APIAction) {
  switch (action.method) {
    case 'home':
      return getRequest('/landing/home');
    default:
      console.info('[ApiManager > handleApiAction > handleLanding] - Unknown method');
      break;
  }
}
